import React, { useState, useEffect } from "react";
import classes from "./Journal.module.css";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import { BASE_URL } from '../../../../Components/Styles/API/API';
import Swal from "sweetalert2";
import crop from "../../../../Assets/repoort.png";
import verified from "../../../../Assets/verified.svg";
import { Modal } from 'react-bootstrap';
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import CurrencyInput from "react-currency-input-field";

function JournalModal({ isOpen, onClose,fetchExpenses }) {
  const [journalRows, setJournalRows] = useState([
    { account: null, account_id: "", account_code: "", description: "", direction: "", amount: "", showDropdown: false }
  ]);
  const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState("");
    const [currencyOptions, setCurrencyOptions] = useState([]);
      const [bearer, setBearer] = useState('');
  const [reference, setReference] = useState("");
  const [loadingRef, setLoadingRef] = useState(false);
  const [transactionDate, setTransactionDate] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
    const navigate = useNavigate();
     const [maxDate, setMaxDate] = useState("");
      const [minDate, setMinDate] = useState("");

  const handlePrinter = () => window.print();

     const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${bearer}`
    };

     const readData = async () => {
          try {
            const value = await localStorage.getItem('userToken');
            const value1 = await localStorage.getItem('tobi');
             const current = await localStorage.getItem('currentMonth');
      
      
            if (value !== null && value.trim() !== '') {
              setBearer(value);
            }
             if (current !== null) {
          console.log(current)
          const date = new Date(current);  // Assume current is in a parsable date format
  
          // setCurrentMonth(date);
          const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
          const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          // Set the min and max date for the date input
  
          const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');  // Add leading zero
            const day = String(date.getDate()).padStart(2, '0');         // Add leading zero
            return `${year}-${month}-${day}`;
        };
          
         setMinDate(formatDate(startOfMonth));
        setMaxDate(formatDate(endOfMonth));
  
         console.log(formatDate(startOfMonth), formatDate(endOfMonth));
  
        }
             else {
              navigate('/login');
              return;
            }
  
      
          } catch (e) {
            alert('Failed to fetch the input from storage');
          }
        };
      
        useEffect(() => {
          readData();
        }, []);
    

  useEffect(() => {
    const fetchReference = async () => {
      console.log('in the Tokennssss');
      const token = localStorage.getItem("userToken");
      if (!token) return;
      setLoadingRef(true);
      try {
        const res = await axios.get(`${BASE_URL}/generate-sales-invoice-code`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        if (res?.data) {
          const payload = res.data;
          const d =
            payload?.data ??
            payload?.code ??
            payload?.reference ??
            payload?.number ??
            payload?.data?.code;
          let ref = "";
          if (typeof d === "string" || typeof d === "number") {
            ref = d;
          } else if (d && typeof d === "object") {
            ref = d.code || d.reference || d.number || "";
          }
          setReference(ref ? String(ref) : "");
        }
      } catch (error) {
        console.error("Error fetching journal reference:", error);
      } finally {
        setLoadingRef(false);
      }
    };

    if (isOpen) {
      fetchReference();
    }
  }, [isOpen]);

  useEffect(() => {
    const fetchAccounts = async () => {
      const token = localStorage.getItem("userToken");
      if (!token) return;
      setAccountsLoading(true);
      try {
        const res = await axios.get(`${BASE_URL}/account/journal_accounts`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        const payload = res?.data;
        let raw = payload?.data ?? payload;
        if (raw && typeof raw === "object" && Array.isArray(raw.data)) {
          raw = raw.data;
        }
        const list = Array.isArray(raw) ? raw : [];
        setAccounts(list);
      } catch (err) {
        console.error("Error fetching accounts:", err);
        setAccounts([]);
      } finally {
        setAccountsLoading(false);
      }
    };

    if (isOpen) {
      fetchAccounts();
    }
  }, [isOpen]);



const totalDebit = journalRows.reduce(
  (sum, entry) =>
    sum + (entry.direction === "1" ? parseFloat(entry.amount || 0) : 0),
  0
);

const totalCredit = journalRows.reduce(
  (sum, entry) =>
    sum + (entry.direction === "2" ? parseFloat(entry.amount || 0) : 0),
  0
);

// fix floating-point precision (round to 2 decimal places)
const fixedDebit = parseFloat(totalDebit.toFixed(2));
const fixedCredit = parseFloat(totalCredit.toFixed(2));



const formatNumber = (num) =>
  Number(num).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 8, // keep up to 8 decimals if necessary
  });


  const addLine = () => {
    setJournalRows(prev => [
      ...prev,
      { account: null, account_id: "", account_code: "", description: "", direction: "", amount: "", showDropdown: false },
    ]);
  };

  const duplicateRow = (index) => {
    setJournalRows(prev => {
      const newRows = [...prev];
      const emptyRow = { account: null, account_id: "", account_code: "", description: "", direction: "", amount: "", showDropdown: false };
      newRows.splice(index + 1, 0, emptyRow);
      return newRows;
    });
  };

  const removeRow = (index) => {
    setJournalRows(prev => {
      if (prev.length === 1) return prev;
      return prev.filter((_, i) => i !== index);
    });
  };

  const handleChange = (index, field, value) => {
    setJournalRows(prev => {
      const newRows = [...prev];
      const row = { ...newRows[index] };

      if (field === "showDropdown") {
        row.showDropdown = value;
      } else if (field === "account") {
        row.account = value;
        row.account_id = value?.id ?? "";
        row.account_code = `${value?.gl_code ?? value?.code ?? ""} - ${value?.gl_name ?? value?.name ?? ""}`;
      } else {
        row[field] = value;
      }

      newRows[index] = row;
      return newRows;
    });
  };

  const fetchCurrency = async () => {
       
        try {
            const response = await axios.get(`${BASE_URL}/fetch-all-currencies`, { headers });
            const results = response.data?.data;
            // console.log(results, "currencis")
            const options = results.map((item) => ({
                label: item.name || item.code,
                value: item.id,
                symbol: item.symbol
            }));
        
            setCurrencyOptions(options);
        } catch (error) {
            const errorStatus = error.response?.data?.message;
            console.log(errorStatus);
          
        } finally {
            
        }
    };

     useEffect(() => {
        if (bearer) {
          fetchCurrency();
        }
      }, [bearer]);

  const handleSaveJournal = async () => {
    if (fixedDebit !== fixedCredit) {
  Swal.fire({
    icon: "warning",
    title: "Not Balanced",
    text: `Total Debit (${fixedDebit}) does not equal Total Credit (${fixedCredit})`,
  });
  return;
}

    // Validation
    // if (
    //   !transactionDate ||
    //   journalRows.some(
    //     row =>
    //       !row.account_id ||
    //       !row.direction ||
    //       !row.amount ||
    //       !row.description
    //   )
    // ) {
    //   Swal.fire("Missing Fields", "Please fill all required fields.", "warning");
    //   return;
    // }

    const payload = {
      jv_number: reference,
      all_debit: fixedDebit,
      all_credit: fixedCredit,
      account_id: journalRows.map(row => row.account_id),
      direction: journalRows.map(row => row.direction),
      transaction_date: journalRows.map(() => transactionDate), // Create array of transactionDate
      description: journalRows.map(row => row.description),
      amount: journalRows.map(row => parseFloat(row.amount)),
    };

    setIsSaving(true);
    try {
      const res = await axios.post(`${BASE_URL}/journal/post-entries`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      Swal.fire({
        imageUrl: verified,
        title: "Success!",
        text: res.data.message || "Journal entry saved successfully!",
        confirmButtonText: "Okay",
        imageWidth: 48,
        imageHeight: 48,
        customClass: {
          title: classes.myTitle,
          popup: classes.myText,
          confirmButton: classes.myButton,
        },
        allowOutsideClick: false,
        preConfirm: () => {
          Swal.close();
        },
      });
      setJournalRows([
        {
          account: null,
          account_id: "",
          account_code: "",
          description: "",
          direction: "",
          amount: ""
        }
      ]);
      setTransactionDate("");
      onClose()
      fetchExpenses()
    } catch (error) {
      const msg = error?.response?.data?.message || "Network error";
      Swal.fire({
        imageUrl: crop,
        imageWidth: 48,
        imageHeight: 48,
        title: "Failed!",
        confirmButtonText: "Okay",
        text: JSON.stringify(msg),
        customClass: {
          title: classes.myTitle,
          popup: classes.myText,
          confirmButton: classes.myDeclineButton,
        },
        allowOutsideClick: false,
        preConfirm: () => {
          Swal.close();
        },
      });
    } finally {
      setIsSaving(false);
    }
  };

  if (!isOpen) return null;

const handleAccountChange = (selectedOption, rowIndex) => {
    setSelectedOptions((prevOptions) => {
      const updatedOptions = [...prevOptions];
      updatedOptions[rowIndex] = selectedOption;
      return updatedOptions;
    });

    const selectedChart = accounts.find((chart) => chart.id === selectedOption.value);

    if (selectedChart) {
      const updatedFormData = [...journalRows];
      updatedFormData[rowIndex].account_id = selectedChart.id;
      updatedFormData[rowIndex].account_code = selectedChart.gl_code;
      setJournalRows(updatedFormData);
    }
  };

  const handleFormChange = (index, field, value) => {
    let formattedValue = value;

    // Format the amount field
    if (field === 'amount' && value !== '') {
      formattedValue = (Number(value.replace(/\D/g, '')) || '').toLocaleString();
    }

    const updatedFormData = [...journalRows];
    updatedFormData[index][field] = formattedValue;
    setJournalRows(updatedFormData);
  };

   const handleValueChange1 = (value, index) => {
    const updatedFormData = [...journalRows];
    updatedFormData[index] = {
      ...updatedFormData[index],
      amount: value,
    };
    setJournalRows(updatedFormData);
  };
 
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size={null}
      backdropClassName={classes.modalBackdrop}
      dialogClassName={classes.modalDialog}
      contentClassName={classes.modalContent}
    >
      <h3 className={classes.title}>Journal Entry — Line Repeater</h3>
      <p className={classes.subtitle}>
        Add multiple journal lines (Account, Description, Debit, Credit). Totals are calculated and validated before submit.
      </p>

      <div className={classes.topRow}>
        <div className={classes.inputGroup}>
          <label>Journal Reference</label>
          <div className={classes.refContainer}>
            {loadingRef ? (
              <div className={classes.spinnerWrapper}>
                <Spinner animation="border" size="sm" />
              </div>
            ) : (
              <input
                type="text"
                value={reference}
                readOnly
                placeholder="Fetching reference..."
              />
            )}
          </div>
        </div>
        <div className={classes.inputGroup}>
          <label>Date</label>
          <input
            type="date"
            value={transactionDate}
            onChange={e => setTransactionDate(e.target.value)}
            required
            min={minDate}
            max={maxDate}
          />
        </div>
        <div className={classes.inputGroup}>
          <label>Currency</label>
         <Select
                     value={
                       selectedCurrency
                         ? currencyOptions.find((option) => option.value === selectedCurrency)
                         : null
                     }
                     onChange={(selectedOption) => setSelectedCurrency(selectedOption?.value || "")}
                     options={currencyOptions}
                     placeholder="Currency"
                     isClearable
                     styles={{
                       control: (base) => ({
                         ...base,
                         minHeight: "32px",
                         height: "32px",
                         fontSize: "12px",
                         borderColor: "#ccc",
                         boxShadow: "none",
                         "&:hover": { borderColor: "#999" },
                       }),
                       valueContainer: (base) => ({
                         ...base,
                         height: "32px",
                         padding: "0 6px",
                       }),
                       input: (base) => ({
                         ...base,
                         margin: 0,
                         padding: 0,
                       }),
                       indicatorsContainer: (base) => ({
                         ...base,
                         height: "32px",
                       }),
                       placeholder: (base) => ({
                         ...base,
                         fontSize: "13px",
                         color: "#888",
                       }),
                       menu: (base) => ({
                         ...base,
                         fontSize: "12px",
                       }),
                     }}
                   />
        </div>
      </div>

      <table className={classes.table}>
  <thead>
    <tr>
      <th>#</th>
      <th>Account Code / Name</th>
      <th style={{ width: "380px" }}>Description</th>
      <th style={{ width: "100px" }}>DR/CR</th>
      <th style={{ width: "170px" }}>Amount</th>
      <th style={{ width: "120px" }}>Actions</th>
    </tr>
  </thead>
  <tbody>
    {journalRows.map((row, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td className={classes.accountCell}>
          {/* --- Account Select --- */}
          <div className={classes.searchableDropdown}>
            <Select
              classNamePrefix="accountSelect"
              placeholder="Search account..."
              isClearable
              isLoading={accountsLoading}
             value={selectedOptions[index]}
              onChange={(selectedOption) => handleAccountChange(selectedOption, index)}
              options={accounts
                .filter((acc) => {
                  const search = row.account_code?.toLowerCase() || "";
                  const text = `${acc.gl_code ?? acc.code ?? ""} ${
                    acc.gl_name ?? acc.name ?? ""
                  }`.toLowerCase();
                  return text.includes(search);
                })
                .map((acc) => ({
                  value: acc.id,
                  label: `${acc.gl_code ?? acc.code ?? ""} - ${
                    acc.gl_name ?? acc.name ?? ""
                  }`,
                }))}
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: "40px",
                  height: "40px",
                  fontSize: "14px",
                  borderColor: "#ccc",
                  borderRadius: "6px",
                  boxShadow: "none",
                  "&:hover": { borderColor: "#999" },
                  textAlign: "left",
                }),
                singleValue: (base) => ({ ...base, textAlign: "left" }),
                placeholder: (base) => ({
                  ...base,
                  fontSize: "14px",
                  color: "#888",
                  textAlign: "left",
                }),
                menu: (base) => ({
                  ...base,
                  fontSize: "13px",
                  zIndex: 20,
                  textAlign: "left",
                }),
                dropdownIndicator: (base) => ({
                  ...base,
                  padding: "4px",
                }),
                clearIndicator: (base) => ({
                  ...base,
                  padding: "4px",
                }),
              }}
            />
          </div>
        </td>

        {/* --- Description --- */}
        <td style={{ width: "380px",height: "50px" }}>
          <input
            type="text"
            value={row.description}
            onChange={(e) => handleFormChange(index, 'description', e.target.value)}
            placeholder="Narration / description"
            style={{
              width: "100%",
              height: "40px",
              padding: "6px 10px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              boxSizing: "border-box",
            }}
          />
        </td>

        {/* --- DR/CR --- */}
        <td style={{ width: "120px",height: "50px" }}>
          <select
            value={row.direction}
            onChange={(e) => handleFormChange(index, "direction", e.target.value)}
            required
            style={{
              width: "100%",
              height: "40px",
              padding: "6px 10px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              boxSizing: "border-box",
            }}
          >
            <option value="">Select</option>
            <option value="1">Debit</option>
            <option value="2">Credit</option>
          </select>
        </td>

        {/* --- Amount --- */}
        <td style={{ width: "180px",height: "50px" }}>
          <CurrencyInput
                                          name={`rowAmount ${index}`} // Provide a unique name for each CurrencyInput
                                          decimalsLimit={2}
                                          value={row.amount}
                                          className="form-control"
                                          onValueChange={(value) => handleValueChange1(value, index)}
                                         style={{
              width: "100%",
              height: "40px",
              padding: "6px 10px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              textAlign: "right",
              boxSizing: "border-box",
            }}
                                        />
          {/* <input
            type="number"
            className={classes.amountInput}
            value={row.amount}
            onChange={(e) => handleFormChange(index, "amount", e.target.value)}
            style={{
              width: "100%",
              height: "40px",
              padding: "6px 10px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              textAlign: "right",
              boxSizing: "border-box",
            }}
          /> */}
        </td>

        {/* --- Actions --- */}
        <td className={classes.actionsCell} style={{ width: "100px",height: "50px" }}>
          {/* <button onClick={() => duplicateRow(index)} className={classes.linkBtn}>
            Duplicate
          </button> */}
          <button onClick={() => removeRow(index)} className={classes.removeBtn}>
            Remove
          </button>
        </td>
      </tr>
    ))}
  </tbody>
</table>


      <div className={classes.actionRow}>
        <button className={classes.addLineBtn} onClick={addLine}>
          + Add Line
        </button>
      </div>

      <div className={classes.totalRow}>
        <div className={classes.totalBox}>
          <span>Total Debit</span>
          <strong> {formatNumber(fixedDebit)}</strong>
        </div>
        <div className={classes.totalBox}>
          <span>Total Credit</span>
         <strong>
  {formatNumber(fixedCredit)}
</strong>

        </div>
      </div>

      <div className={classes.footerButtons}>
        <button
          className={classes.resetBtn}
          onClick={() =>
            setJournalRows([
              { account: null, account_id: "", account_code: "", description: "", direction: "", amount: "", showDropdown: false }
            ])
          }
        >
          Reset
        </button>
        <button className={classes.printBtn} onClick={handlePrinter}>Print</button>
        <button
          className={classes.submitBtn}
          onClick={handleSaveJournal}
          disabled={isSaving}
        >
          {isSaving ? (
            <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
              <Spinner animation="border" size="sm" />
              Saving...
            </span>
          ) : (
            "Submit Journal"
          )}
        </button>
      </div>

      <button className={classes.closeBtn} onClick={onClose}>
        ×
      </button>
    </Modal>
  );
}

export default JournalModal;
